// extracted by mini-css-extract-plugin
module.exports = {"before":"OverlayScrollContainer_before__1QNVj","after":"OverlayScrollContainer_after__3maYY","container":"OverlayScrollContainer_container__bPl6a"};